import React from 'react';
import { useCustomElement } from '../UseCustomElement';

export type ZuiSpinnerProps = {
  active?: true | null;
  alt?: string;
} & React.HTMLAttributes<HTMLElement>;

export const ZuiSpinner = (props: ZuiSpinnerProps) => {
  const selector = 'zui-spinner';
  const customMappings = {};
  return useCustomElement(selector, props, customMappings);
};
